module.exports = __webpack_public_path__ + "media/service_features/number_04-978479d2.svg";